<div *ngIf="isInitialized">
  <lh-manage-booking *ngIf="legacyMode"></lh-manage-booking>
  <lh-manage-booking-timeline *ngIf="!legacyMode"></lh-manage-booking-timeline>
</div>
